import { render, staticRenderFns } from "./StockEditUnit.vue?vue&type=template&id=4a89743f"
import script from "./StockEditUnit.vue?vue&type=script&lang=js"
export * from "./StockEditUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports